import helper from "actions/helper";

export default function ReoportClients(items) {
    if (!items || items.length < 1)
        return false;

    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "border",
        start: [3, 1],
        end: [3, 3]
    }, {
        name: "bold",
        start: [1, 1],
        end: [1, 8]
    }];

    const width = [
        { key: 'A', width: 20 },
        { key: 'B', width: 20 },
        { key: 'C', width: 20 },
        { key: 'D', width: 20 },
        { key: 'E', width: 20 },
        { key: 'F', width: 20 },
    ];

    const text = [
        [`Отчет сформирован`],
        ["Пациент", "Номер счета", "Дата рождения", "Номер телефона", "Скидка", "Статус", "Узнал про клинику", "Источник регистрации"]
    ];

    items.forEach(it => {
        const { lname, fname, sname, profileNumber, birthday, phoneNumber, discount, status, knowAboutClinicId } = it;

        text.push([
            `${lname} ${fname} ${sname}`,
            profileNumber,
            birthday,
            phoneNumber,
            discount + "%",
            status,
            knowAboutClinicId,
            "-",
        ]);
    });

    const data = { text, style, width };

    helper.xlsx.exportToExcel(data, "ReportSalary.xlsx");

}
